export function getComments() {
  return fetch('/api/admin/comments/');
}

export function acceptComment(commentId: string) {
  return fetch(`/api/admin/comments/${commentId}/accept`, {
    method: 'POST',
  });
}

export function rejectComment(commentId: string) {
  return fetch(`/api/admin/comments/${commentId}/reject`, {
    method: 'POST',
  });
}
